import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Translation } from '~/i18n/types';
import './ListButton.pcss';

interface Props {
  text: Translation;
  tabIndex?: number;
  title?: string;
  disabled?: boolean;
  onClick(): void;
}

const ListButton: React.FC<Props> = ({ disabled = false, ...props }) => {
  return (
    <button
      type="button"
      className="ListButton"
      disabled={disabled}
      title={props.title}
      tabIndex={props.tabIndex}
      onClick={props.onClick}
    >
      <FormattedMessage {...props.text} />
    </button>
  );
};

export default React.memo(ListButton);
